import { Checkbox as AntdCheckbox } from 'antd'
import React from 'react'
import styled from 'styled-components'

const StyledCheckbox = styled(AntdCheckbox)`
  .ant-checkbox + span {
    padding-left: 12px;
  }
`
export const LabelWrapper = styled.div`
  
  font-size: ${props =>
  props.isCustom ? '14px' : '12px'};
  line-height: 24px;
  font-weight: 600;

  color: ${props =>
  props.isCustom ? '#343E59' : '#707070'};
  font-weight: ${props =>
  props.isCustom ? '500' : '600'};
  white-space: ${props => props.wrap ? 'normal' : 'nowrap'};
`

const Checkbox = ({ onChange, label, value, disabled = false, isCustom = false, ...rest }) => {
  return (
    <StyledCheckbox
      {...rest}
      onChange={onChange}
      value={value}
      disabled={disabled}
    >
      <LabelWrapper isCustom={isCustom}>{label}</LabelWrapper>
    </StyledCheckbox>
  )
}
export default Checkbox
